import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getItems } from '../../../api/items';

import { mergeItemsListWithUserData } from '../../../utils/items';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { generateItemCIDKey } from '../utils/generateItemCIDKey';

export const fetchLayout = createAsyncThunk(
  'items/fetchLayout',
  async ({ path, params }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await getItems(path, {
        cancelToken: source.token,
        params: {
          // default options
          by: 'edited',
          order: 'desc',
          direction: 'down',
          ...params,
        },
      });
      const [itemsResponse, userDataMapResponse] = response;
      return {
        data: mergeItemsListWithUserData(itemsResponse, userDataMapResponse),
        headers: itemsResponse.headers,
      };
    } catch (error) {
      return rejectWithValue(error.response?.status);
    }
  },
);

export const fetchLayoutExtraReducers = {
  [fetchLayout.pending]: (state, action) => {
    checkAndSetLoadingWithId(
      state.items.layouts.request,
      action,
      action.meta.arg.key,
    );
  },
  [fetchLayout.fulfilled]: (state, action) => {
    const layoutKey = action.meta.arg.key;

    onMatchedRequest(state.items.layouts.request[layoutKey], action, () => {
      const { payload } = action;
      const NEXT_LINK = 'x-link-next';
      const isFirstPage = !action.meta.arg.params?.offset;
      const layout = state.items.layouts.byId[layoutKey];

      payload.data.items.forEach(item => {
        const itemCIDKey = generateItemCIDKey(item);
        state.items.item.byId[itemCIDKey] = item;

        state.items.layouts.paginationNext[layoutKey] =
          payload.headers[NEXT_LINK];

        if (!state.items.item.allIds.includes(itemCIDKey))
          state.items.item.allIds.push(itemCIDKey);
      });

      if (!layout || isFirstPage) {
        state.items.layouts.byId[layoutKey] = payload.data.layout;

        return;
      }

      state.items.layouts.byId[layoutKey].push(...payload.data.layout);
    });
  },
  [fetchLayout.rejected]: (state, action) => {
    handleRequestRejection(
      state.items.layouts.request[action.meta.arg.key],
      action,
    );
  },
};
